import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=2f939436"
import script from "./SizeChart.vue?vue&type=script&lang=js"
export * from "./SizeChart.vue?vue&type=script&lang=js"
import style0 from "./SizeChart.vue?vue&type=style&index=0&id=2f939436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports